module.exports = __webpack_public_path__ + "img/ostoja_spokoju_ii.a8592832.jpg";